import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/docker/actions-runner/_work/gatsby-mdx-suite/gatsby-mdx-suite/themes/docs/src/templates/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Columns = makeShortcode("Columns");
const Column = makeShortcode("Column");
const TextBlock = makeShortcode("TextBlock");
const Font = makeShortcode("Font");
const List = makeShortcode("List");
const ListItem = makeShortcode("ListItem");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Gatsby MDX Suite`}</h1>
    <p>{`The Gatsby MDX Suite lets you build fast loading static sites with reusable components.`}</p>
    <h2>{`Quick Start`}</h2>
    <Columns maxColumns="4" mdxType="Columns">
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">🐣</Font>
      <br />
      Setup
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link to="/docs/get-started/" mdxType="Link">Get started</Link>
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link to="/docs/style-guide/#fonts" mdxType="Link">Fonts</Link>
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link to="/docs/style-guide/#icons" mdxType="Link">Icons</Link>
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link to="/docs/style-guide/#colors" mdxType="Link">Colors</Link>
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link to="/docs/style-guide/#sizes" mdxType="Link">Sizes</Link>
      </ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">📐</Font>
      <br />
      Layouts
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-layout/section" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-layout/columns" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-layout/column" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-boxes/boxes" mdxType="Link" />
      </ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">🎨</Font>
      <br />
      Branding
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-copy/font" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-copy/text-block" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-copy/claim" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-copy/list" mdxType="Link" />
      </ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">📸</Font>
      <br />
      Media
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-image/image" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-copy/icon" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-video/video" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-youtube/youtube-video" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-layout/floating-image" mdxType="Link" />
      </ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">🌟</Font>
      <br />
      Animations
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-animation/animate" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">More...</ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">😱</Font>
      <br />
      Special Elements
    </TextBlock>
    <List defaultIcon="star" mdxType="List">
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-timeline/timeline" mdxType="Link" />
      </ListItem>
      <ListItem mdxType="ListItem">
        <Link id="@gatsby-mdx-suite/mdx-instagram/instagram-post" mdxType="Link" />
      </ListItem>
    </List>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">⁉️</Font>
      <br />
      Help
    </TextBlock>
    <Link href="https://github.com/axe312ger/gatsby-mdx-suite/issues" mdxType="Link">
      FAQ - Support - Feedback
    </Link>
  </Column>
  <Column mdxType="Column">
    <TextBlock tag="h2" align="center" mdxType="TextBlock">
      <Font size="4xl" mdxType="Font">😎</Font>
      <br />
      Special Request
    </TextBlock>
    <Link href="https://github.com/axe312ger/gatsby-mdx-suite/issues" mdxType="Link">
      Crazy ideas? Let us know!
    </Link>
  </Column>
    </Columns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      